import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import mineCraftApi from 'src/api/mineCraftApi';
import { ServerPlanInterface } from 'src/store/mine_craft/serverPlansSlice';

export const serverPlansEntity = new schema.Entity('serverPlans');
export const serverPlanEntity  = new schema.Entity('serverPlan');

const fetchServerPlansCollection = async (url: string, params: object = {}) => {
  const response   = await mineCraftApi.get(url, { params })
  const normalized = normalize<
    any,
    {
      serverPlans: { [key: string]: ServerPlanInterface };
    }
  >(response.data.server_plans, [serverPlansEntity]);

  return {
    serverPlans: normalized.entities?.serverPlans || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      serverPlan: ServerPlanInterface;
    }
  >(response.data.server_plan, serverPlanEntity);
  return normalized.entities;
}

export const fetchServerPlans = createAsyncThunk(
  'serverPlans/fetchServerPlans',
  async (params: object = {}) => {
    return fetchServerPlansCollection('/onesky/server_plans', params);
  }
);

export const fetchServerPlan = createAsyncThunk(
  'serverPlans/fetchServerPlan',
  async (id: number | string) => {
    const response = await mineCraftApi.get(`/onesky/server_plans/${id}`);
    return normalizeInstance(response);
  }
);

export const createServerPlan = createAsyncThunk(
  'serverPlans/createServerPlan',
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.post('/onesky/server_plans', data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateServerPlan = createAsyncThunk(
  'serverPlans/updateServerPlan',
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.patch(`/onesky/server_plans/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const destroyServerPlan = createAsyncThunk(
  'serverPlans/destroyServerPlan',
  async (id: number) => {
    const response = await mineCraftApi.delete(`/onesky/server_plans/${id}`);
    return response.data;
  }
);

export const reorderServerPlans = createAsyncThunk(
  'serverPlans/reorderServerPlans',
  async ({ ids }: { ids: any }, { rejectWithValue }) => {
    try {
      await mineCraftApi.patch('/onesky/server_plans/reorder', { ids })

      return { ids };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);
